import { topicWall } from '@/mocks/homeData';
import SectionHeading from '@/pages/home/components/SectionHeading';

const levelStyles: Record<string, string> = {
  hot: 'bg-primary-500 text-white',
  warm: 'bg-accent-100 text-accent-900 border border-accent-200',
  normal: 'bg-background-50 text-foreground-700 border border-background-300',
};

const guides = [
  { id: 1, icon: 'ri-search-eye-line', text: '点话题先看来源标注，未证实的会打上问号' },
  { id: 2, icon: 'ri-route-line', text: '每个话题都有时间线，按发生顺序排' },
  { id: 3, icon: 'ri-chat-smile-2-line', text: '讨论区只聊事、不撕人，说话留三分' },
];

export default function TopicWall() {
  return (
    <section id="topics" className="border-b border-background-200 bg-background-100 py-12 md:py-16">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <SectionHeading
          eyebrow="话题墙"
          title="大家今天都在聊什么"
          desc="把正在发酵的话题贴成一整面墙，热度越高、字越大；挑一个进去，直接看讨论现场。"
        />

        <div className="mt-8 grid grid-cols-1 gap-6 lg:grid-cols-[1fr_300px]">
          <div className="flex flex-wrap gap-3">
            {topicWall.map((topic) => (
              <a
                key={topic.id}
                href="#gossip"
                className={`flex items-center gap-2 rounded-full px-4 py-2 text-sm font-medium transition hover:opacity-90 ${levelStyles[topic.level]}`}
              >
                <span className="whitespace-nowrap">{topic.name}</span>
                <span className="rounded-full bg-black/10 px-1.5 py-0.5 text-xs font-normal">
                  {topic.count}
                </span>
              </a>
            ))}
          </div>

          <aside className="rounded-lg border border-background-200 bg-background-50 p-5">
            <h3 className="flex items-center gap-2 text-sm font-bold text-foreground-950">
              <i className="ri-compass-3-line text-primary-600"></i>
              上墙之前先看三条
            </h3>
            <ul className="mt-4 space-y-3">
              {guides.map((guide) => (
                <li key={guide.id} className="flex items-start gap-2.5">
                  <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-md bg-secondary-100 text-secondary-900">
                    <i className={guide.icon}></i>
                  </span>
                  <span className="text-xs leading-relaxed text-foreground-600">{guide.text}</span>
                </li>
              ))}
            </ul>
            <a
              href="#join"
              className="mt-5 flex items-center justify-center gap-1.5 whitespace-nowrap rounded-md bg-accent-500 px-3 py-2 text-xs font-bold text-white transition hover:bg-accent-600"
            >
              <i className="ri-add-line"></i>
              开个自己的话题
            </a>
          </aside>
        </div>
      </div>
    </section>
  );
}